// Ilustração das telas vazias, nas cores da marca
function VazioYrm() {
  return (
    <svg viewBox='0 0 120 72' width='120' height='72' aria-hidden='true' style={{ display: 'block', margin: '0 auto' }}>
      <rect x='18' y='14' width='70' height='46' rx='6' fill='none' stroke='var(--yrm-border-strong)' strokeWidth='2' />
      <rect x='30' y='6' width='70' height='46' rx='6' fill='var(--yrm-surface)' stroke='var(--yrm-border-strong)' strokeWidth='2' />
      <path d='M42 22h46M42 32h30' stroke='var(--yrm-border-strong)' strokeWidth='3' strokeLinecap='round' />
      <circle cx='92' cy='50' r='11' fill='var(--yrm-surface)' stroke='#d6a93a' strokeWidth='2.5' />
      <path d='M100 58l8 8' stroke='#d6a93a' strokeWidth='3' strokeLinecap='round' />
    </svg>
  )
}

export default VazioYrm
